/*** IMPORTS FROM imports-loader ***/
var define = false;
var module = false;
var exports = false;
(function() {

require("trunk8");

}.call(window));